export type PluginReadinessOptions = {
  isReady: boolean
  requireReady?: boolean
  notReadyMessage: string
}

// Typed so the flush can tell "source data is mid-cascade" (retry after the
// next commit) apart from a real plugin failure (rethrow immediately).
export class PluginNotReadyError extends Error {}

export function checkPluginReadiness({ isReady, requireReady, notReadyMessage }: PluginReadinessOptions) {
  if (isReady) return true
  if (requireReady) throw new PluginNotReadyError(notReadyMessage)
  return false
}

export function isQueryLoaded(dataUpdatedAt: number | null | undefined) {
  return (dataUpdatedAt ?? 0) > 0
}
